import type { Brand } from 'types/brands'

// return all brands and subbrands at same level
export const flatBrands = (brands: Brand[]): Brand[] => {
	const flattedBrands: Brand[] = []

	for (const brand of brands) {
		flattedBrands.push(brand)
		if (brand.subBrands) {
			for (const subBrand of flatBrands(brand.subBrands)) {
				flattedBrands.push(subBrand)
			}
		}
	}

	return flattedBrands
}
